import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChange, ElementRef } from '@angular/core';
import { HomeService } from '../../../routes/home/home.service';
import { environment } from '../../../../environments/environment';
import { ActivityPostService } from '../../../routes/home/socialboard/services/socialboard.service';


declare var $: any;

@Component({
    selector: 'app-navsearch',
    templateUrl: './navsearch.component.html',
    styleUrls: ['./navsearch.component.scss']
})
export class NavsearchComponent implements OnInit, OnChanges {

    @Input() visible: boolean;
    @Output() onclose = new EventEmitter<boolean>();
    term: string;

    constructor(public elem: ElementRef, private appService: HomeService, private activityPostService: ActivityPostService) { }

    ngOnInit() {
        $(document)
            .on('keyup', event => {
                if (event.keyCode === 27) {// ESC
                    this.closeNavSearch();
                }
            })
            .on('click', event => {
                if (!$.contains(this.elem.nativeElement, event.target)) {
                    this.closeNavSearch();
                }
            })
            ;
    }

    closeNavSearch() {
        this.visible = false;
        this.onclose.emit();
        this.term = undefined;
    }

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        // console.log(changes['visible'].currentValue)
        if (changes['visible'].currentValue === true) {
            this.elem.nativeElement.querySelector('input').focus();
        }
    }

    handleForm() {
        this.appService.searchResults = null;
        this.appService.clearPostToolsForSearch = true;
        console.log('Form submit: ' + this.term);
        this.appService.searchTerm = this.term;
        this.appService.showSearchResults = true;
        this.appService.isSearchResultsLoading = true;
        this.activityPostService.updateBaseUrl(environment.endpoints.activityPostModerateApi + this.activityPostService.firstPageParams);
        this.appService.getSearchResults(this.term);
    }

}



// WEBPACK FOOTER //
// C:/Projects/Isagenix/GitHub/Mobile.IsaLifeAzure/apps/qualia-platform-admin-web/src/app/layout/header/navsearch/navsearch.component.ts